export { default } from './BotoSubscripcio';
